<div class="fui-heading-container">
  <fui-heading [text]="'account.gift_cards_title' | translate" [level]="5"></fui-heading>
  <button class="fui-action-btn" (click)="appService.goToFenderShop('products/fender-digital-gift-card', true)">
    <fa-icon icon="shopping-cart"></fa-icon>
    {{ "account.buy_gift_card" | translate }}
  </button>
</div>
@if (loading) {
  <myp-skeleton-loader type="list-item" [number]="5" extraContainerClass="m-y-20"></myp-skeleton-loader>
}
@if (!loading && !giftCards?.length) {
  <div class="m-y-20 text-muted">{{ "account.no_gift_cards" | translate }}</div>
}
@for (card of giftCards; track card) {
  <myp-list-item
    [title]="card.code"
    [metadata]="card.metadata"
    [showImage]="true"
    photo="https://cdn.shopify.com/s/files/1/0862/0608/7463/files/GiftCard-FenderOriginal.png?v=1747942094"
    [includeChevron]="false"
    [imageRound]="false"
    [largeImage]="true"
  ></myp-list-item>
}
